import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43038dcf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "主题色更换", -1));
const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref } from 'vue';
import { useStore } from 'vuex';
import { generateNewStyle, writeNewStyle } from '@/utils/theme';
export default {
  __name: 'SelectColor',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;

    // 预定义色值
    const predefineColors = ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', 'rgba(255, 69, 0, 0.68)', 'rgb(255, 120, 0)', 'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)', '#c7158577'];
    const store = useStore();
    // 默认色值
    const mColor = ref(store.getters.mainColor);

    /**
     * 关闭
     */
    const closed = () => {
      emits('update:modelValue', false);
    };
    /**
     * 确定
     * 1. 修改主题色
     * 2. 保存最新的主题色
     * 3. 关闭 dialog
     */

    const comfirm = async () => {
      // 1.1 获取主题色
      const newStyleText = await generateNewStyle(mColor.value);
      // 1.2 写入最新主题色
      writeNewStyle(newStyleText);
      // 2. 保存最新的主题色
      store.commit('theme/setMainColor', mColor.value);
      // 3. 关闭 dialog
      closed();
    };
    return (_ctx, _cache) => {
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "提示",
        "model-value": __props.modelValue,
        onClose: closed,
        width: "22%",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: closed
        }, {
          default: _withCtx(() => [_createTextVNode("cancel")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: comfirm
        }, {
          default: _withCtx(() => [_createTextVNode("confirm")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_color_picker, {
          modelValue: mColor.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => mColor.value = $event),
          predefine: predefineColors
        }, null, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};